import API_CONFIG from '../config/api';

const BASE_URL = API_CONFIG.BASE_URL;
const GYMS = API_CONFIG.ENDPOINTS.GYMS;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
  'Content-Type': 'application/json'
});

const handleResponse = async (res) => {
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.error || 'Error en la petición');
  }

  return data;
};

export const GymsService = {
  listar: async (page = 1, limit = 10, search = '') => {
    let url = `${BASE_URL}${GYMS.LISTAR}?page=${page}&limit=${limit}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    const res = await fetch(url, {
      headers: authHeaders()
    });

    const data = await handleResponse(res);

    // Compatibilidad con formato nuevo
    return {
      items: data.items || [],
      pagination: data.pagination || {
        page: 1,
        limit: 10,
        total: data.items?.length || 0,
        total_pages: 1,
        has_next: false,
        has_prev: false
      }
    };
  },

  crear: async (payload) => {
    const res = await fetch(`${BASE_URL}${GYMS.CREAR}`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(payload)
    });

    return handleResponse(res);
  },

  editar: async (id, payload) => {
    const res = await fetch(`${BASE_URL}${GYMS.EDITAR(id)}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(payload)
    });

    return handleResponse(res);
  },

  eliminar: async (id) => {
    const res = await fetch(`${BASE_URL}${GYMS.ELIMINAR(id)}`, {
      method: 'DELETE',
      headers: authHeaders()
    });

    return handleResponse(res);
  }
};

